"use strict";

if (global._babelPolyfill) {
  throw new Error("only one instance of babel/polyfill is allowed");
}
global._babelPolyfill = true;

require("core-js/shim");

require("regenerator-babel/runtime");


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-core/lib/babel/polyfill.js
 ** module id = 90
 ** module chunks = 0
 **/